import { render, staticRenderFns } from "./MdVideoPlayer.vue?vue&type=template&id=32380238&scoped=true&"
import script from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./MdVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MdVideoPlayer.vue?vue&type=style&index=0&id=32380238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32380238",
  null
  
)

export default component.exports